import {remCalc} from '_themeUtils'

/**
 * Theme for the `32_accordion` Page Designer layout module (organism `AccordionPd`).
 *
 * The module is a collapsible content container with NO header of its own (it is opened by an
 * external CTA). `wrapper` is the full-width block; `panel` holds the revealed children. Spacing
 * follows the Figma design "32 - Accordion / Text accordion" and the reference storefront's
 * collapsible content (`.cc-pd-accordion-wrp`).
 */
const accordionPd = {
    AccordionPd: {
        baseStyle: () => ({
            wrapper: {
                w: '100%',
                gridColumn: '1 / -1',
            },
            // Revealed content wrapper (`.cc-pd-accordion-wrp`, no CSS in SFRA).
            //
            // Horizontal: 24px per side on mobile only. Figma "Text accordion" mobile (7363:27331) and
            // SFRA `.cc-content-text` at xs (`100% - 48px`) agree. From md up the text width is fixed by
            // the child (Figma 680px / 890px), so the panel adds no lateral inset.
            //
            // Vertical: Figma on every breakpoint. 40px gap below the trigger CTA plus the 10px
            // "Text accordion" padding on top (no 50 token), 10px at the bottom. Padding, not margin,
            // so the space lives inside the Collapse and disappears when the accordion is closed.
            //
            // The revealed child is a `12_titleTextCta` module. `AccordionPd` provides an "inside
            // accordion" context that `TitleTextCta` reads to adapt its width (Figma 680px md, 890px lg+)
            // and top spacing.
            panel: {
                w: '100%',
                px: {base: 'spacing.6', md: 0},
                pt: remCalc(50),
                pb: 'spacing.2.5',
            },
        }),
    },
}

export default accordionPd
